import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/sharp-regular-svg-icons/faArrowUpRightFromSquare';

import React, { useCallback } from 'react';

import { Button } from 'ui-components/components/button';

import style from './style.module.less';
import { getSSRSingleSignOnToken } from '../../../../../../store/returns/returns.api';

export const SsrSignOnButton = ({ label, path = '', shouldShowIcon = true, storeGuid, theme = 'tertiary' }) => {
  const onConfigureReturnStore = useCallback(async () => {
    try {
      const response = await getSSRSingleSignOnToken(storeGuid);
      if (response?.token) {
        const host = window.SS_GLOBALS.frontEndConfig.ssrConfigHost;
        let redirectUrl = `${host}/seller-signin?token=${response?.token}&store_guid=${storeGuid}`;
        if (path !== '') {
          redirectUrl += `&redirect_path=${encodeURIComponent(path)}`;
        }
        // oxlint-disable-next-line @typescript-eslint/no-unused-expressions,no-unused-expressions
        window.open(redirectUrl, 'ssrconfig') || window.location.replace(redirectUrl);
      }
    } catch (error) {
      // oxlint-disable-next-line no-console
      console.log('onConfigureReturnStore - error', error);
    }
  }, [path, storeGuid]);

  return (
    <Button className={style.button} onClick={onConfigureReturnStore} theme={theme}>
      {label}
      {shouldShowIcon ? <FontAwesomeIcon className={style.icon} icon={faArrowUpRightFromSquare} /> : null}
    </Button>
  );
};
